import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
// eslint-disable-next-line max-len
import { VehicleMaintenanceScheduleServiceDue } from '@quorum/models/xs-resource';
import {
  LastWorkOrderForVehicleQueryParameters,
  VehicleMaintenanceScheduleServiceDueQueryParameters,
} from '@quorum/models/xs-query';

export const GET_ACCEPTED_SERVICES_ON_TRANSACTION_FROM_SERVER =
  '[VEHICLE_MAINTENANCE] Get Accepted Services On Transaction From Server';
export class GetAcceptedServicesOnFromServer implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = GET_RO_HISTORY_FOR_SERVICES_DUE_FROM_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: { vehicleId: number; queryParams: LastWorkOrderForVehicleQueryParameters }) {}
}

export const GET_RO_HISTORY_FOR_SERVICES_DUE_FROM_SERVER =
  '[VEHICLE_MAINTENANCE] Get RO History For Services Due From Server';
export class GetRoHistoryForServicesDueFromServer implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = GET_RO_HISTORY_FOR_SERVICES_DUE_FROM_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: { vehicleId: number; queryParams: LastWorkOrderForVehicleQueryParameters }) {}
}

export const GET_SERVICES_DUE_FROM_SERVER = '[VEHICLE_MAINTENANCE] Get Services Due From Server';
export class GetServicesDueFromServer implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = GET_SERVICES_DUE_FROM_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: VehicleMaintenanceScheduleServiceDueQueryParameters) {}
}

export const GET_RO_HISTORY_FOR_SERVICES_DUE_FROM_SERVER_SUCCESS =
  '[VEHICLE_MAINTENANCE] Get RO History For Services Due From Server SUCCESS';
export class GetRoHistoryForServicesDueFromServerSuccess implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = GET_RO_HISTORY_FOR_SERVICES_DUE_FROM_SERVER_SUCCESS;
  readonly triggerStorageSync = false;
  constructor(public payload: { roHistory: Update<any>[] }) {}
}

export const GET_SERVICES_DUE_FROM_SERVER_SUCCESS = '[VEHICLE_MAINTENANCE] Get Services Due From Server Success';
export class GetServicesDueFromServerSuccess implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = GET_SERVICES_DUE_FROM_SERVER_SUCCESS;
  readonly triggerStorageSync = false;

  constructor(public payload: { servicesDue: VehicleMaintenanceScheduleServiceDue[] }) {}
}

export const GET_RO_HISTORY_FOR_SERVICES_DUE_FROM_SERVER_FAILURE =
  '[VEHICLE_MAINTENANCE] Get RO History For Services Due From Failure';
export class GetRoHistoryForServicesDueFromServerFailure implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = GET_RO_HISTORY_FOR_SERVICES_DUE_FROM_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: string }) {}
}

export const GET_SERVICES_DUE_FROM_SERVER_FAILURE = '[VEHICLE_MAINTENANCE] Get Services Due From Server Failure';
export class GetServicesDueFromServerFailure implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = GET_SERVICES_DUE_FROM_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any }) {}
}

export const CLEAR_SERVICES_DUE_IN_STATE = '[VEHICLE_MAINTENANCE] Clear Services Due In State';
export class ClearServicesDueInState implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = CLEAR_SERVICES_DUE_IN_STATE;
  readonly triggerStorageSync = false;
  constructor(public payload: any) {}
}

export type ServicesDueAction =
  | GetRoHistoryForServicesDueFromServer
  | GetRoHistoryForServicesDueFromServerSuccess
  | GetRoHistoryForServicesDueFromServerFailure
  | GetServicesDueFromServer
  | GetServicesDueFromServerSuccess
  | GetServicesDueFromServerFailure
  | ClearServicesDueInState;
